import { useConfig } from '@hooks/other/useConfig';
import React from 'react';
import { Container, Typography } from '@mui/material';
import Copyright from '../components/Copyright';
import { useBranding } from '../contexts/BrandingContext';
import { useLocalStorage } from '../contexts/LocalStorageContext';

export const LoginPageLayout = ({ children }: { children: React.ReactNode }) => {
  const { branding } = useBranding();
  const config = useConfig();
  const darkLoginLogo = branding?.loginLogoDark || branding.loginLogo;
  const isDark = !!useLocalStorage()?.localStorageState?.isDark;
  const loginLogo = isDark ? darkLoginLogo : branding.loginLogo;

  return (
    <Container
      maxWidth="xs"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {loginLogo}
      <Typography component="h1" variant="h4" sx={{ mt: 5 }}>
        {config.branding.app_name || 'Registry'}
      </Typography>
      {children}
      <Copyright />
    </Container>
  );
};
